<template>
  <v-container fluid>
    <v-row>
      <!-- result -->
      <v-col cols="12" md="8">
        <wapi-panel :title="'Результаты'" v-if="result.length">
          <template v-slot:content>
            <v-tabs background-color="primary" dark>
              <v-tab>Таблица1</v-tab>
              <v-tab>JSON</v-tab>
              <v-tab-item>
                <v-expansion-panels v-model="panel">
                  <v-expansion-panel
                    v-for="(forecast, index) in forecastPoints"
                    v-bind:key="'forecast_' + index"
                    @click="panelClick(index)"
                  >
                    <v-expansion-panel-header>{{ index }} [{{ forecast.latitude }}, {{ forecast.longitude }}] {{ forecast.predict }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col>
                          <v-chip-group column active-class="primary--text"></v-chip-group>
                        </v-col>
                      </v-row>
                      <div class="mx-2">
                        <v-switch dense v-model="groupBy" :label="`adfadf`"></v-switch>
                      </div>
                      <v-row v-if="groupBy">
                        <v-card>
                          <v-tabs background-color="red lighten-2" dark show-arrows>
                            <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
                            <v-tab
                              v-for="parameters in forecast.parameters"
                              v-bind:key="parameters.id"
                            >{{ parameters.predict / 60 }}</v-tab>
                            <v-tab-item
                              v-for="parameters in forecast.parameters"
                              v-bind:key="parameters.id"
                            >
                              <v-simple-table>
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <th>Тип уровня</th>
                                      <th>Значение уровня</th>
                                      <th>Название парметра</th>
                                      <th>Ед. измерения</th>
                                      <th>Значение</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="data in parameters.parameters" v-bind:key="data.id">
                                      <th>{{ data.level_type }}</th>
                                      <th>{{ data.level }}</th>
                                      <td>{{ data.pname }}</td>
                                      <td>{{ data.unit }}</td>
                                      <td>{{ data.value }}</td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-tab-item>
                          </v-tabs>
                        </v-card>
                      </v-row>
                      <v-row v-if="groupBy">
                        <v-card>
                          <v-tabs background-color="red lighten-2" dark show-arrows>
                            <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
                            <v-tab
                              v-for="parameters in forecast.parameters"
                              v-bind:key="parameters.id"
                            >{{ parameters.predict / 60 }}</v-tab>
                            <v-tab-item
                              v-for="parameters in forecast.parameters"
                              v-bind:key="parameters.id"
                            >
                              <v-simple-table>
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <th>Тип уровня</th>
                                      <th>Значение уровня</th>
                                      <th>Название парметра</th>
                                      <th>Ед. измерения</th>
                                      <th>Значение</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="data in parameters.parameters" v-bind:key="data.id">
                                      <th>{{ data.level_type }}</th>
                                      <th>{{ data.level }}</th>
                                      <td>{{ data.pname }}</td>
                                      <td>{{ data.unit }}</td>
                                      <td>{{ data.value }}</td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-tab-item>
                          </v-tabs>
                        </v-card>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <json-viewer expanded :expand-depth="5" :value="result" copyable boxed sort></json-viewer>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </template>
        </wapi-panel>
      </v-col>
      <v-col cols="4">
        <!-- map -->
        <wapi-panel :title="'Настройки запроса'" v-if="result.length" :spacing="false">
          <template v-slot:content>
            <div style="height: 415px;" v-if="showMap">
              <l-map ref="map" :zoom="13" :center="center">
                <l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
                <l-geo-json ref="geoJsonLayer" :geojson="geojson" :options="geoJsonOptions" />
                <l-marker
                  v-for="point in points"
                  v-bind:key="point.id"
                  :lat-lng="[point.latitude, point.longitude]"
                  :icon="point.icon"
                  @click="selectMarkerHandler(point)"
                ></l-marker>
              </l-map>
            </div>
          </template>
        </wapi-panel>
        <!-- diagrams -->
        <wapi-panel :title="title" v-if="chartsSeries.length">
          <template v-slot:content>
            <v-row v-for="(series, index) in chartsSeries" v-bind:key="series.id">
              <v-col>
                <apexchart
                  type="line"
                  height="350"
                  :options="chartsOptions[index]"
                  :series="series"
                ></apexchart>
              </v-col>
            </v-row>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
    <v-overlay v-if="loading" style="z-index: 99998">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import WapiContract from "../models/contract/WapiContract";
import Point from "../models/point";
import Rectangle from "../models/rectangle";
import ForecastPoint from "../models/forecastpoint";
import WapiPanel from "../components/WapiPanel";
import settings from "../settings.json";
import L from "leaflet";
import { uniqWith } from "lodash";

export default {
  name: "ForecastResultView",
  title: "Прогноз",
  components: {
    WapiPanel
  },
  async mounted() {
    await this.forecastResult();
  },
  props: {
    forecastParams: String
  },
  data: function() {
    return {
      groupBy: false,
      componentKey: 0,
      loading: false,
      showMap: true,
      panel: [],
      chartPoint: {},
      forecastPoints: [],
      points: [],
      rectangles: [],
      presets: [],
      contractModel: new WapiContract(),
      geoJsonOptions: {
        onEachFeature: (feature, layer) => {
          const bounds = layer.getBounds();
          layer.getLatLng = function() {
            return this.getBounds().getCenter();
          };
          layer.setLatLng = function() {};
          layer._latlng = layer.getLatLng();
          this.$refs.map.mapObject.fitBounds(bounds);
        }
      },
      dvariants: [],
      predicts: [],
      geojson: null,
      presetId: "",
      result: [],
      chartsSeries: [],
      chartsOptions: [],
      chartOptions: this.getChartOptions(),
      selectedMarkerColor: "#583470",
      selectedMarkerStyles: `background-color: ${this.selectedMarkerColor};
                          width: 3rem;
                          height: 3rem;
                          display: block;
                          left: -1.5rem;
                          top: -1.5rem;
                          position: relative;
                          border-radius: 3rem 3rem 0;
                          transform: rotate(45deg);
                          border: 1px solid #FFFFFF`,
      iconSelectedMarker: L.icon({
        iconUrl: "/marker-icon-red.png"
      }),
      center: settings.center,
      zoom: settings.zoom
    };
  },
  computed: {
    title: function() {
      return `График для точки ${this.chartPoint.latitude}, ${this.chartPoint.longitude}]`;
    }
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    async forecastResult() {
      const request = JSON.parse(this.forecastParams);

      await this.$store.dispatch("FETCH_PRESET", {
        id: request.preset_id,
        user_id: request.user_id
      });
      const preset = this.$store.getters.PRESET;
      request.area = preset.area;
      this.loading = true;
      this.forceRerender();
      // если есть поле "domain" значит происходит запрос прогноза с расширенными настройками
      if (request.extended) {
        await this.$store.dispatch(
          "FETCH_LAST_FORECAST_PRESET_BY_PARAMS",
          request
        );
      } else {
        await this.$store.dispatch("FETCH_LAST_FORECAST_PRESET", request);
      }
      this.loading = false;

      this.result = this.$store.getters.FORECAST_PRESET;

      this.predicts = request.predicts.map(x => x / 60);

      const uniqPoints = uniqWith(
        this.result,
        (locationA, locationB) =>
          locationA.location.geometry.coordinates[1] ===
            locationB.location.geometry.coordinates[1] &&
          locationA.location.geometry.coordinates[0] ===
            locationB.location.geometry.coordinates[0]
      );

      let num = 0;
      this.points = uniqPoints.map(x => {
        const p = new Point();
        p.latitude = x.location.geometry.coordinates[1];
        p.longitude = x.location.geometry.coordinates[0];
        p.id = num++;
        p.icon = new L.Icon.Default();

        return p;
      });

      this.forecastPoints = this.points.map(x => {
        const p = new ForecastPoint();
        p.latitude = x.latitude;
        p.longitude = x.longitude;
        p.id = x.id;
        const parameters = this.result.filter(
          z =>
            z.location.geometry.coordinates[1] == p.latitude &&
            z.location.geometry.coordinates[0] == p.longitude
        );
        parameters.sort((a, b) => {
          return a.predict - b.predict;
        });
        p.parameters = parameters;
        return p;
      });

      this.geojson = request.area;

      const rects = [];
      let i = 1;
      for (let el of this.result) {
        const bottomLeft = {
          lat: el.location.geometry.coordinates[1] - el.tile_size.ts_lat,
          lon: el.location.geometry.coordinates[0] - el.tile_size.ts_lon
        };

        const topRight = {
          lat: el.location.geometry.coordinates[1] + el.tile_size.ts_lat,
          lon: el.location.geometry.coordinates[0] + el.tile_size.ts_lon
        };

        const rect = new Rectangle();
        rect.id = i++;
        rect.bounds = [
          [bottomLeft.lat, bottomLeft.lon],
          [topRight.lat, topRight.lon]
        ];
        rect.style = {
          color: "red",
          fillColor: "#f03",
          fillOpacity: 0.5
        };

        rects.push(rect);
      }

      this.rectangles = rects;
      this.drawCharts(this.forecastPoints[0]);
    },
    drawCharts(point) {
      this.chartPoint = point;

      const parameters = this.chartPoint.parameters[0].parameters;
      for (let parameter of parameters) {
        const chartOptions = this.getChartOptions();
        chartOptions.yaxis.title.text = parameter.unit;
        chartOptions.title.text = `Тип уровня: ${parameter.level_type} Уровень ${parameter.level}`;
        chartOptions.xaxis.categories.push(...this.predicts);
        this.chartsOptions.push(chartOptions);

        this.chartsSeries.push([
          {
            id: parameter.id,
            name: parameter.name,
            data: this.chartPoint.parameters.map(
              x =>
                x.parameters.find(
                  p =>
                    p.name === parameter.name &&
                    p.level === parameter.level &&
                    p.level_type === parameter.level_type
                ).value
            )
          }
        ]);
      }
    },
    resetCharts() {
      this.chartsOptions = [];
      this.chartsSeries = [];
    },
    resetRectangles() {
      this.rectangles = [];
    },
    resetPoints() {
      this.result = [];
      this.points = [];
      this.forecastPoints = [];
    },
    reset() {
      this.resetPoints();
      this.resetRectangles();
      this.resetCharts();
    },
    async selectMarkerHandler(point) {
      this.selectMarker(point);

      const index = this.forecastPoints.findIndex(x => x.id === point.id);
      if (index != -1) {
        this.panel = index;
        this.resetCharts();
        this.drawCharts(this.forecastPoints[index]);
      }
    },
    async selectMarker(point) {
      this.points.forEach(x => {
        if (x.id === point.id) {
          x.icon = this.iconSelectedMarker;
        } else {
          x.icon = new L.Icon.Default();
        }
      });
    },
    getChartOptions() {
      return {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "straight"
        },
        title: {
          text: "",
          align: "left"
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5
          }
        },
        xaxis: {
          type: "numeric",
          categories: [],
          title: {
            text: "Заблаговременнности"
          }
        },
        yaxis: {
          title: {
            text: ""
          }
        }
      };
    },
    async onChangeUser() {
      await this.$store.dispatch("FETCH_PRESETS", this.userId);
      this.presets = this.$store.getters.PRESETS;
    },
    async onChangePreset() {
      const preset = this.presets.find(p => p.id === this.presetId);
      this.geojson = preset.area;
    },
    filteredForecastData(predict) {
      if (this.forecastData.length) {
        return this.forecastData.find(f => f.predict === predict).parameters;
      }
      return [];
    },
    async panelClick(val) {
      // this.showMap = false;
      // await this.$store.dispatch('SET_LOADING', true);
      const point = this.points[val];

      if (point) {
        this.selectMarker(point);
        // setTimeout(this.selectMarker(point), 5000);
      }
      // await this.$store.dispatch('SET_LOADING', false);
      // this.showMap = true;
    }
  },
  watch: {
    async forecastParams() {
      this.reset();
      await this.forecastResult();
    }
  }
};
</script>